<div class="chart">
  <canvas baseChart [type]="type" [data]="data" [options]="chartOptions"></canvas>
</div>
